//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseBuilder.js";
import "../no/ugmath.js";
import "../no/Diagramming.js";
let d=[[[0,"InterruptionPointName",1,0],[0,"InterruptionPointVariant",1,0]],[[["starSource"],"SetStarSource",{},1,0],[["interruptionPoint"],"SetDestinationInterruptionPoint",{},1,0],[["point"],"SetInterruptionPointLocation",{},1,0],[["pageObject"],"CreateInterruptionPointNode",{R_:{nodeObject:"Diagramming.Node"}},1,0]],[]];
SPLM.AME.InterruptionPointBuilder = class extends SPLM.AME.AMEBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.InterruptionPointBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.InterruptionPointBuilder.Variant = Object.freeze({
    "A" : "A", "B" : "B", "C" : "C", "D" : "D", "E" : "E", "F" : "F", "G" : "G", "H" : "H"});

export default SPLM;